import { useMemo } from 'react';

import { RoverBrand, RoverBrandContextType } from '@rover/types';

export const useRoverBrandProvider = (brand: RoverBrand): RoverBrandContextType => {
  return useMemo(() => {
    const isCatInAFlat: boolean = brand === RoverBrand.CatInAFlat;
    const isRover: boolean = brand === RoverBrand.Rover;

    return { brand, isCatInAFlat, isRover };
  }, [brand]);
};
